import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatDateLL, objToFormData } from "../../algorithms";
import {
  customStyle,
  nativeStyleEnd,
  positionStyle,
} from "../../algorithms/styleDirection";
import { addPostComment } from "../../API/store/actions/discussion/discussion";
import { paths } from "../../paths/paths";
import CommentIcon from "../reusableComponents/commentIcon";
import ModalComponent from "../reusableComponents/modal";
import Button from "../sharedComponents/buttons/button";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import FileInput from "../sharedComponents/inputs/fileInput";
import TextArea from "../sharedComponents/textarea/textArea";
import DeleteProcAlert from "../tasks/editProc.js/deleteProc";
import { resolver } from "./../../API/middlewares/resolveRequests";
import { EditForumData } from "./../../API/store/actions/discussion/discussion";
import {
  formikSetup,
  initialValues,
  validationSchema,
} from "../tasks/formikValidation";
import EditDiscussionForm from "./discussionEditForm";
import { useSelector } from "react-redux";

const DiscussionCard = ({
  userToken,
  item,
  showComments = {},
  userLogged,
  procAdded,
  setProcAdded,
  fromCommunity = false,
  show,
  setshow,
}) => {
  const community = useSelector((state) => state.community.communityId);
  const submit = async (values) => {
    values.ForumId = parseInt(item.id);
    values.MemberId = parseInt(userLogged?.memberId);

    let data = objToFormData(values);
    let res = await addPostComment(data, userToken);
  };
  const formik = useFormik(
    formikSetup(initialValues, undefined, validationSchema, "comment", submit)
  );
  const {
    values,
    handleChange,
    setFieldValue,
    touched,
    errors,
    handleSubmit,
  } = formik;
  const isFocus = showComments[item.id];
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [data, setData] = useState(null);
  const [VisibleEditProc, setVisibleEditProc] = useState(false);

  useEffect(() => {
    if (data) setVisibleEditProc(true);
  }, [data]);

  window.onclick = function (event) {
    if (
      !event.target.matches(".icon") &&
      !event.target.matches(".icon svg path")
    ) {
      var sharedowns = document.getElementsByClassName(
        `${customStyle("dropdown-menu-discussion")}`
      );
      for (let i = 0; i < sharedowns?.length; i++) {
        var openSharedown = sharedowns[i];
        if (openSharedown?.classList?.contains("show")) {
          openSharedown?.classList?.remove("show");
          setshow({ id: null, display: false });
        }
      }
    }
  };

  return (
    <>
      <ModalComponent
        body={
          <DeleteProcAlert
            userToken={userToken}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
            discussionId={item?.id}
            setVisible={setDeleteModalVisible}
            content={"هل تريد حذف النقاش والتعليقات التابعة له؟"}
          />
        }
        hasImage={
          <img
            src="/assets/images/deleteicon.png"
            width={20}
            height={20}
            alt=""
          />
        }
        size={"s"}
        modalVisible={deleteModalVisible}
        setModalVisible={setDeleteModalVisible}
        title={"هل انت متاكد"}
        background={"modalBackground mx-5"}
      />
      <ModalComponent
        body={
          <EditDiscussionForm
            userToken={userToken}
            setVisible={setVisibleEditProc}
            forumData={data}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />
        }
        hasImage={
          <img
            src="/assets/images/greeniconedit.svg"
            width={20}
            height={20}
            alt=""
          />
        }
        setModalVisible={setVisibleEditProc}
        modalVisible={VisibleEditProc}
        size={"xl"}
        title={"تعديل النقاش"}
      />
      <div
        className="w-100 my-3"
        style={{
          border: "solid 1px #DFDFE2",
          borderRadius: 10,
          cursor: "pointer",
          zIndex: 0,
        }}
      >
        <div className="d-flex justify-content-between px-2">
          <Link
            to={`/discussion/${item.id}`}
            style={{ textDecoration: "none" }}
            className="col"
          >
            <div className="px-4 py-2" id={item.id}>
              <div style={{ color: "#000000", fontWeight: "bold" }}>
                {item.title}
              </div>
              <div className="text-muted my-2" style={{ fontSize: 13 }}>
                {formatDateLL(item.createDate)}
              </div>
              <div style={{ color: "#444444" }}>{item.description}</div>
              <div
                className=" d-flex align-items-center my-3"
                style={{ color: "#000000" }}
              >
                <div className="mx-2">
                  <img
                    src={`${paths.Members}${item.memberId}/${item.memberPhoto}`}
                    style={{ width: 30, height: 30, borderRadius: 10 }}
                    alt={""}
                  />
                </div>
                <div className="mx-2">{item.memberName}</div>
              </div>
            </div>
          </Link>
          <div>
            {!fromCommunity && (
              <div className="col d-flex justify-content-end align-items-end btn-group">
                {show?.id == item?.id ? (
                  <>
                    <div
                      style={{ display: show.display ? "block" : "none" }}
                      className={`${customStyle("arrow-horizontal-discussion")}
                       ${show.display ? "show" : ""}
                      `}
                    ></div>
                    <ul
                      className={`${customStyle("dropdown-menu-discussion")} ${
                        show.display ? "show" : ""
                      }`}
                      style={{
                        display: show.display ? "block" : "none",
                      }}
                    >
                      {item?.memberId == userLogged?.memberId ? (
                        <li
                          style={{ cursor: "pointer" }}
                          id={item.id}
                          onClick={() => {
                            resolver(
                              EditForumData,
                              setData,
                              item.id,
                              userToken
                            );
                          }}
                        >
                          <span
                            className={`dropdown-item ${customStyle(
                              "dropdown-item"
                            )}`}
                          >
                            تعديل النقاش
                          </span>
                        </li>
                      ) : null}

                      {item?.memberId == userLogged?.memberId ||
                      community?.adminCommunity == true ? (
                        <li
                          style={{ cursor: "pointer" }}
                          id={item.id}
                          onClick={() => {
                            setDeleteModalVisible(true);
                          }}
                        >
                          <span
                            className={`dropdown-item ${customStyle(
                              "dropdown-item"
                            )}`}
                          >
                            حذف النقاش
                          </span>
                        </li>
                      ) : null}
                    </ul>
                  </>
                ) : null}

                {item?.memberId == userLogged?.memberId ||
                community?.adminCommunity == true ? (
                  <Icon
                    containerStyle={"mt-2 icon"}
                    id={item.id}
                    name="ellipsis-v"
                    size={18}
                    className=" d-flex icon"
                    style={{ display: "block" }}
                    onclick={(e) => {
                      const id = e.currentTarget.id;
                      id == null
                        ? setshow({
                            id,
                            display: true,
                          })
                        : id == show.id
                        ? setshow({
                            id: null,
                            display: false,
                          })
                        : setshow({
                            id,
                            display: true,
                          });
                    }}
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>

        {/* <div
          id={item.id}
          className=" d-flex align-items-center px-4"
          style={{
            height: 50,
            backgroundColor: "#F2F2F2",
            borderRadius: 10,
            zIndex: 999,
          }}
          onClick={(e) => {
            setShowComments({
              //   ...showComments,
              [e.currentTarget.id]: !isFocus,
            });
          }}
        >
          <div className="mx-2">
            <CommentIcon count={item.commentsCount} />
          </div>
          <div className="mx-2"> اضف تعليق</div>
        </div> */}
      </div>
      {/* {showComments[item.id] === true ? (
        <form onSubmit={handleSubmit} style={{ display: "contents" }}>
          <div className="col-12 position-relative bg-white">
            <TextArea
              placeholder={"اضف تعليق ..."}
              // containerStyle={"col-11"}
              rows={2}
              style={{ ...nativeStyleEnd("padding", 80) }}
              name={"Description"}
              onChange={handleChange}
            />
            <div
              style={{
                position: "absolute",
                top: 0,
                ...positionStyle(0),
              }}
            >
              <Button
                type={"submit"}
                content={"اضف"}
                height={54}
                styleClass={"solid"}
                customStyle={{ width: 60 }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                bottom: 18,
                ...positionStyle(47),
              }}
              className="px-2"
            >
              <FileInput
                name={"Attachment"}
                onChange={(e) => {
                  setFieldValue("Attachment", e.target.files[0]);
                }}
                iconName={"paperclip"}
                iconPrefix={"fas"}
                size={15}
                iconColor={values.Attachment ? "#1a73e8" : "#C7C7C9"}
                backgroundSize={15}
                backgroundColor={"white"}
                fileName={" "}
                containerStyle={""}
                accept={".gif, .jpg, .png, .doc, .pdf, .xlsx"}
              />
            </div>
          </div>
        </form>
      ) : null} */}
    </>
  );
};

export default DiscussionCard;
